import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { message } from "antd";
import ArrowPipeline from "./TaskArrowPipeline";
import { TaskUpdate } from '../../../../Api/Services/TaskapiService';


const DealStageDemo = ({ UrlId, leadStatusData, displayData, getDetailsData, setNaCTrigger, successMessage, AutomationMessage, setErrorData, setIsModalVisible1 }) => {
    const stages = leadStatusData.slice(0, 3);
    const extraStages = leadStatusData.slice(3);
    const [current, setCurrent] = useState();
    const [disabled, setDisabled] = useState(false);
    const onSubmit = async (id) => {
        setNaCTrigger("trigger")
        setCurrent(id)
        let hideMessage;
        setDisabled(true)
        try {
            const payload = {
                taskStatusId: id
            }
            hideMessage = message.loading("Loading...", 0);
            const response = await TaskUpdate(payload, UrlId[1])
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
                else {
                    const isAutomation = response.data[0].message === AutomationMessage;
                    setDisabled(false)
                    hideMessage();
                    setNaCTrigger("CallBack")
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);
                    } else {
                        message.success("Task status updated successful");
                    }
                    getDetailsData()
                }
            }
        }
        catch (error) {
            hideMessage();
            setDisabled(false)
            message.error(error)
        }
    }
    useEffect(() => {
        if (displayData) {
            setCurrent(displayData?.task_status_id)
        }
    }, [displayData?.task_status_id])
    return (
        <div>
            <div style={{
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "15px",
                display: "flex", alignItems: "center", gap: 5
            }}>
                Task Status  <div className={`table_list_clicks status-text Task${displayData?.task_status_id}`} style={{ fontSize: 10 }}> {displayData?.task_status_name}</div >
            </div>
            <ArrowPipeline
                stages={stages}
                currentStage={current === 4 || current === 5 || current === 6 ? null : current}
                onStageClick={(index) => onSubmit(index)}
                completedColor="#007bff"
                upcomingColor="#e0e0e0"
                textColor="#fff"
                arrowHeight={40}
                notchSize={6}
                disabledItem={disabled}
            />
            <div style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 15
            }}>
                {extraStages.map((item) => (
                    <div key={item.taskStatusId} className={current === item.taskStatusId ? "status-upadte-arrow-selected" : "status-upadte-arrow"}
                        role="button"
                        tabIndex={0}
                        style={{ cursor: (disabled || item.taskStatusId === current) ? "default" : "pointer" }}
                        onClick={() => (disabled || item.taskStatusId === current) ? undefined : onSubmit(item.taskStatusId)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                onSubmit(item.taskStatusId)
                            }
                        }}
                    >
                        {item.taskStatusName}
                    </div>
                ))}
            </div>
        </div>
    );
};

DealStageDemo.propTypes = {
    UrlId: PropTypes.array.isRequired,
    getDetailsData: PropTypes.func.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    leadStatusData: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
    successMessage: PropTypes.func.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    setErrorData: PropTypes.func.isRequired,
    setIsModalVisible1: PropTypes.func.isRequired,
};

export default DealStageDemo;

